/**
 * Created by fers on 05.02.16.
 */
/* @flow */

import React from 'react';
import PropTypes from 'prop-types';
import types from '../../common/model-api/types';
import Relay from 'react-relay';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';
import AppPanel from '../fw/AppPanel.react';
import GridList, {processPagingParams} from '../fw/GridList.react';
import {defaultPageSize} from '../fw/PagingGrid.react';
import {getLastOrganisationId} from '../app/LastOrganisationId';

import urlMapping from '../app/URLMapping';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'channelAddonAdd.title', 'defaultMessage': 'Adding Application Addon'},
    search: {id: 'channelAddonAdd.search', 'defaultMessage': 'Search'}
});

interface ChannelAddonAddStep1Props {
    intl: IntlShape;
    relay: object;
    user: User;
}

class ChannelAddonAddStep1 extends React.Component<ChannelAddonAddStep1Props> {

    static propTypes = {
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
    };
    typeName = 'channelAddons';

    constructor(props) {
        super(props);
    }

    onChange = (event) => {
        let lastValue = event.target.value;

        /* wait 250 ms after last change */
        if (this.delayTimeout) {
            clearTimeout(this.delayTimeout);
        }

        this.delayTimeout = setTimeout(() => {
            this.props.relay.setVariables({
                searchName: lastValue
            });
        }, 250);
    };

    getUrl = (item) => {
        return urlMapping.getUrl(types[this.typeName], 'create-step-1', {
            organisation_id: this.props.user.organisation.realId,
            channel_id: this.props.user.organisation.channel.realId,
            addonDef_id: item['realId']
        });
    };

    render() {
        const {channel} = this.props.user.organisation;
        const {addonDefsToAdd} = this.props.user;

        return (
            <AppPanel breadcrumbParams={[
                {type: types['organisations'], data: this.props.user.organisation},
                {type: types['channels'], data: channel},
            ]} title={this.props.intl.formatMessage(messages.title)}>
                <div className="input-group" style={{maxWidth: '200px', marginBottom: '1em'}}>
                    <input className="form-control" name="search" onChange={this.onChange} placeholder={this.props.intl.formatMessage(messages.search)} type="text" />
                    <span className="input-group-addon" id="basic-addon2"><span className="fa fa-search"/></span>
                </div>

                <GridList
                    defaultIcon="dativery"
                    edges={addonDefsToAdd}
                    getUrl={this.getUrl}
                    iconProperty="channelDef.icon"
                    metadata={types['addonDefs']}
                    pageInfo={addonDefsToAdd.pageInfo}
                    relay={this.props.relay}
                    tagsProperty="state"
                    titleProperty="name"
                    urlMapping={urlMapping}
                />
            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(injectIntl(ChannelAddonAddStep1), (props) => {
    return props.user.organisation && props.user.organisation.channel;
}), {
    initialVariables: {
        organisationId: '',
        channelId: '',
        first: defaultPageSize,
        after: null,
        searchName: '',
    },
    prepareVariables (variables) {
        processPagingParams(variables);

        if (!variables.organisationId) {
            variables.organisationId = getLastOrganisationId();
        }

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    realId,
                    name,
                    channel(id: $channelId) {
                        id,
                        realId,
                        organisation_id,
                        name,
                        channelDef {
                            id,
                            name
                        },
                    }
                },
                addonDefsToAdd(first: $first, after: $after, nameLike: $searchName) {
                    edges {
                        node {
                            id,
                            realId,
                            state,
                            name,
                            channelDef {
                                id,
                                name,
                                icon
                            }
                        }
                    },
                    pageInfo {
                        hasNextPage,
                        hasPreviousPage,
                        startCursor,
                        endCursor
                    }
                }
            }
        `,
    },
});
